const CurrencyFormatter = (locale, currency, minimumFractionDigits) => {
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        minimumFractionDigits,
    });
};

export default CurrencyFormatter